window.$ = window.jQuery = require("jquery");
window._ = require("lodash");
